import { INFTMetadata } from "@interfaces/Metadata/NFTMetadata";
import { t } from "i18next";

export const validateDataLink = (asset: INFTMetadata) => {
  return !asset ? `${t("core:validators:data-link-empty")}` : undefined;
};
